import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

interface DeliveryWindow {
  start: string;
  end: string;
}

interface UpdateDeliveryWindowPayload {
  taskId: string;
  deliveryWindow: DeliveryWindow;
}

interface UpdateDeliveryWindowParams {
  packageId: string;
  payload: UpdateDeliveryWindowPayload;
}

export const useUpdateDeliveryWindow = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ packageId, payload }: UpdateDeliveryWindowParams) => {
      const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/v1/package/${packageId}/updateDeliveryWindow`, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    },
    onSuccess: (_data, variables) => {
      // Invalidate and refetch tracking details after successful reschedule
      queryClient.invalidateQueries(['trackingDetails', variables.packageId]);
    }
  });
};
